module.exports = __webpack_public_path__ + "static/media/app.9177b56d.jpg";